import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { SessionData, SessionService } from "@app/core/services/session.service";
import { BehaviorSubject } from "rxjs";

@Component({
    selector: "app-distribution-policy-mor-annex-5",
    templateUrl: "./distribution-policy-mor-annex-5.component.html",
    styleUrls: ["../legal-documents.scss"],
    standalone: false,
})
export class DistributionPolicyMorAnnex5Component {
    defaultValueForInput = "[To be completed by Certified Developer]";
    name: BehaviorSubject<string> = new BehaviorSubject<string>(this.defaultValueForInput);
    address: BehaviorSubject<string> = new BehaviorSubject<string>(this.defaultValueForInput);
    nameAndEmail: BehaviorSubject<string> = new BehaviorSubject<string>(this.defaultValueForInput);
    techAndOrgMeasures: BehaviorSubject<string> = new BehaviorSubject<string>(this.defaultValueForInput);
    companyCountry: BehaviorSubject<string> = new BehaviorSubject<string>(this.defaultValueForInput);
    companyStorageLocation: BehaviorSubject<string> = new BehaviorSubject<string>(this.defaultValueForInput);
    companyIntention: BehaviorSubject<string> = new BehaviorSubject<string>(this.defaultValueForInput);
    transmitionChannel: BehaviorSubject<string> = new BehaviorSubject<string>(this.defaultValueForInput);
    localLaws: BehaviorSubject<string> = new BehaviorSubject<string>(this.defaultValueForInput);
    publicAuthorityRequests: BehaviorSubject<string> = new BehaviorSubject<string>(this.defaultValueForInput);
    otherMeasures: BehaviorSubject<string> = new BehaviorSubject<string>(this.defaultValueForInput);

    hasAllUserInfo: boolean = false;

    constructor(private sessionService: SessionService, private route: ActivatedRoute) {}

    ngOnInit() {
        const accountUid = this.route.snapshot.queryParams.accountUid;

        if (accountUid) {
            this.getAccountDataByUid(accountUid);
        } else {
            this.sessionService.sessionData.subscribe({
                next: (sessionData: SessionData) => {
                    if (sessionData && sessionData.account) {
                        this.getAccountDataByUid(sessionData.account.uid);
                    }
                },
            });
        }
    }

    getAccountDataByUid(accountUid: string) {
        this.sessionService.getAccountData(accountUid).subscribe({
            next: (account) => {
                if (!account) return;
                this.name.next(account.settings["name"]);
                this.address.next(account.settings["address"]);
                this.nameAndEmail.next(`${account.settings["developer.distributionPolicy.contactPersonName"]}, ${account.settings["developer.distributionPolicy.contactPersonEmailAddress"]}`);
                this.techAndOrgMeasures.next(account.settings["developer.distributionPolicy.dataSecurityMeasures"]);
                this.companyCountry.next(account.settings["developer.distributionPolicy.companyLocation"]);
                this.companyStorageLocation.next(account.settings["developer.distributionPolicy.companyTransferredDataStorageLocation"]);
                this.companyIntention.next(account.settings["developer.distributionPolicy.companyOnwardTransferIntention"]);
                this.transmitionChannel.next(account.settings["developer.distributionPolicy.transmissionChannel"]);
                this.localLaws.next(account.settings["developer.distributionPolicy.isCompanySubjectToLocalLaws"]);
                this.publicAuthorityRequests.next(account.settings["developer.distributionPolicy.hasCompanyReceivedDiscloseRequests"]);
                this.otherMeasures.next(account.settings["developer.distributionPolicy.personalDataSafeguardMeasureDetails"]);
            },
        });
    }
}
